export class MimeTypes {
  static DOCX = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
  static URL = 'application/x-www-form-urlencoded'
  static BINARY = 'application/octet-stream'
  static TEXT = 'plain/text'
  static GIF = 'image/gif'
  static PNG = 'image/png'
  static WEBP = 'image/webp'
  static JPEG = 'image/jpeg'
  static BMP = 'image/bmp'
  static SVG = 'image/svg+xml'
  static JSON = 'application/json'
}
